import BatchPaymentIcon from '@images/icons/batch-payment.svg?react'
import ExpensesIcon from '@images/icons/expenses2-icon.svg?react'
import PlusIcon from '@images/icons/plus2.svg?react'
import cn from 'classnames'
import { useLazyFetchTransactionApprovalMatrixQuery } from 'mmfintech-backend-api'
import { GlobalContext, tr, useDropDownMenu, useOutsideClick } from 'mmfintech-commons'
import { useContext } from 'react'
import { CreateEditExpensesMatrixModal } from '../CreateEditExpensesMatrixModal'
import TransactionApprovalMatrixModal, {
  TRANSACTION_APPROVAL_MATRIX_MODAL_MODE
} from '../TransactionApprovalMatrixModal'

import './customApprovalMatrixDropdown.scss'

const MENU_ITEMS_ID = {
  TRANSACTIONS: 'transactions',
  EXPENSES: 'expenses'
}

const MENU_ITEMS = [
  {
    id: MENU_ITEMS_ID.TRANSACTIONS,
    label: 'FRONTEND.USER_DEPARTMENT_MANAGEMENT.TRANSACTIONS_MATRIX',
    fallback: 'Transactions matrix',
    icon: <BatchPaymentIcon />
  },
  {
    id: MENU_ITEMS_ID.EXPENSES,
    label: 'FRONTEND.USER_DEPARTMENT_MANAGEMENT.EXPENSES_MATRIX',
    fallback: 'Expenses matrix',
    icon: <ExpensesIcon />
  }
]

export const CustomApprovalMatrixDropdown = () => {
  const { modalShow } = useContext(GlobalContext)
  const { visible, toggleDropDown, hideDropDown } = useDropDownMenu()
  const dropdownRef = useOutsideClick(() => hideDropDown())

  // Use lazy query to only fetch when needed
  const [fetchMatrix] = useLazyFetchTransactionApprovalMatrixQuery()

  const handleClick = (e: React.BaseSyntheticEvent) => {
    e.stopPropagation()
    toggleDropDown()
  }

  const handleItemClick = async (itemId: string) => {
    if (itemId === MENU_ITEMS_ID.EXPENSES) {
      hideDropDown()
      modalShow({
        header: tr('FRONTEND.USER_DEPARTMENT_MANAGEMENT.EXPENSES_MATRIX', 'Expenses Matrix'),
        content: <CreateEditExpensesMatrixModal />
      })
    } else if (itemId === MENU_ITEMS_ID.TRANSACTIONS) {
      hideDropDown()

      // Fetch latest matrix data to determine mode
      const { data: latestMatrix, isError } = await fetchMatrix()

      // Check if matrix exists (data exists and no 404 error)
      const modalMode =
        latestMatrix && !isError
          ? TRANSACTION_APPROVAL_MATRIX_MODAL_MODE.EDIT
          : TRANSACTION_APPROVAL_MATRIX_MODAL_MODE.CREATE
      const header =
        latestMatrix && !isError
          ? tr('FRONTEND.TRANSACTION_MATRIX.EDIT_TITLE', 'Edit transaction approval matrix')
          : tr('FRONTEND.TRANSACTIONS_MATRIX', 'Transaction Approval Matrix')

      modalShow({
        header,
        content: <TransactionApprovalMatrixModal modalMode={modalMode} />
      })
    }
  }

  return (
    <div className={cn('custom-approval-matrix-dropdown', { visible })} ref={dropdownRef}>
      <div className='custom-approval-matrix-toggler-wrapper' onClick={handleClick}>
        <div className='matrix-icon'>
          <PlusIcon />
        </div>
        <span className='custom-approval-matrix-toggler-text'>
          {tr('FRONTEND.USER_DEPARTMENT_MANAGEMENT.CUSTOM_APPROVAL_MATRIX', 'Custom Approval Matrix')}
        </span>
      </div>

      <div className='matrix-dropdown-menu'>
        <div className='matrix-dropdown-items'>
          {MENU_ITEMS.map(item => (
            <div
              key={item.id}
              onClick={() => handleItemClick(item.id)}
              className={cn('matrix-dropdown-item', { visible })}
            >
              {item.icon}
              <p>{tr(item.label, item.fallback)}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
